import { ApiActions } from '../../constants/ApiActions';
import { Map } from '../../lib/ImmutableUtils';
import { createReducer } from '../../lib/ReducerUtils';

const INITIAL_STATE = Map<$TSFixMe>({});
export type EntitiesCategoriesState = typeof INITIAL_STATE;

// CATEGORIES ENTITY REDUCER
export default createReducer(INITIAL_STATE, {
  [ApiActions.FETCH_GENRE_CATEGORIES_SUCCESS]: saveCategoryData,
  [ApiActions.GET_MUSIC_CATALOG_SUCCESS]: saveCategoryData,
});

// CASE FUNCTIONS

function saveCategoryData(
  state: EntitiesCategoriesState,
  action: $TSFixMe,
): EntitiesCategoriesState {
  return state.mergeDeep(action.response.entities.categories);
}
